import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS,
  FILTER_PROMOS_BY_CATEGORY,
  FILTER_PROMOS_BY_PAYMENT_METHOD,
  FILTER_PROMOS_BY_BOOKING_TYPE
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, set, remove } from "firebase/database";

export const fetchPromos = () => (dispatch) => {

  const {
    promoRef
  } = firebase;

  dispatch({
    type: FETCH_PROMOS,
    payload: null
  });
  onValue(promoRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_PROMOS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_PROMOS_FAILED,
        payload: "No promos available."
      });
    }
  });
};

// Fungsi baru untuk filter promo berdasarkan kategori
export const filterPromosByCategory = (category) => (dispatch) => {
  dispatch({
    type: FILTER_PROMOS_BY_CATEGORY,
    payload: category
  });
};

// Fungsi baru untuk filter promo berdasarkan payment method
export const filterPromosByPaymentMethod = (paymentMethod) => (dispatch) => {
  dispatch({
    type: FILTER_PROMOS_BY_PAYMENT_METHOD,
    payload: paymentMethod
  });
};

// Fungsi baru untuk filter promo berdasarkan booking type
export const filterPromosByBookingType = (bookingType) => (dispatch) => {
  dispatch({
    type: FILTER_PROMOS_BY_BOOKING_TYPE,
    payload: bookingType
  });
};

// Fungsi untuk mendapatkan promo yang applicable
export const getApplicablePromos = (category, service, paymentMethod) => (dispatch, getState) => {
  const state = getState();
  const allPromos = state.promodata.promos || [];
  
  const applicablePromos = allPromos.filter(promo => {
    // Check if promo is active and not expired
    const now = new Date().getTime();
    const isValid = promo.promo_validity && now <= promo.promo_validity;
    
    if (!isValid) return false;
    
    // Check category specific promo
    if (promo.category_specific && promo.categories) {
      if (!promo.categories.includes(category)) return false;
    }
    
    // Check service specific promo
    if (promo.service_specific && promo.services) {
      if (!promo.services.includes(service)) return false;
    }
    
    // Check payment method specific promo
    if (promo.payment_method_specific && promo.payment_methods) {
      if (!promo.payment_methods.includes(paymentMethod)) return false;
    }
    
    return true;
  });
  
  return applicablePromos;
};

export const editPromo = (promo, method) => (dispatch) => {
  const {
    promoRef, 
    promoEditRef
  } = firebase;
  dispatch({
    type: EDIT_PROMOS,
    payload: { method, promo }
  });
  if (method === 'Add') {
    push(promoRef, promo);
  } else if (method === 'Delete') {
    remove(promoEditRef(promo.id));
  } else {
    set(promoEditRef(promo.id),promo);
  }
}